const state = () => {
  return {
    offenceIcons: {
      Bribery: "DollarSignIcon",
      Embezzlement: "BriefcaseIcon",
      Forgery: "EditIcon",
      Fraud: "UserXIcon",
      Impersonation: "UsersIcon",
      Misappropriation: "RepeatIcon",
      Scam: "ShieldOffIcon",
      Stealing: "BriefcaseIcon",
      "Abuse of office": "HomeIcon",
      "Currency counterfeit": "DollarSignIcon",
      "Cyber crime/fraud": "MonitorIcon",
      "False declaration of assets": "ClipboardIcon",
      "Giving false information": "PhoneOutgoingIcon",
      "Illegal dealing in oil products": "DatabaseIcon",
      "Money laundering": "DollarSignIcon",
      "Obstruction of justice": "AlertTriangleIcon",
      "Destruction of evidence": "AlertOctagonIcon",
      "Diversion of public funds": "CornerRightDownIcon",
      "Visa Scam": "FileMinusIcon",
      "Forgery/Illegal Possession of Fake Document(s)": "EditIcon",
      "Employment Scam": "UsersIcon",
      "Vote Buying": "UsersIcon",
      "Operating Illegal University/College": "HomeIcon",
      "Criminal Negligence": "EyeOffIcon",
      "Examination Malpractice": "CopyIcon"
    }
  };
};

// getters
const getters = {
  offenceIcons: state => state.offenceIcons
};

// actions
const actions = {};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
